/* eslint-disable react/prop-types */
import React from "react";
import type ConstructionAllDetailsGuiDto from "../../../../dto/construction/ConstructionAllDetailsGuiDto";
import type GuiValueDto from "../../../../dto/construction/GuiValueDto";
import ConstructionTableFixedCell from "../table/ConstructionTableFixedCell";
import ConstructionTableToggleCell from "../table/ConstructionTableToggleCell";
import MastTooltip from "../table/MastTooltip";

interface CheckForAcceptedMastFoundationFootplateProps {
  data: ConstructionAllDetailsGuiDto | null;
  constructionElementEntityId: string;
  constructionElementParentId: string;
  constructionElementsName: string;
  constructionElementProperty: string;
  isChecked: () => boolean;
  header: string;
  exceptionCells: string[];
  guiValue: GuiValueDto<string | number | boolean>;
  formatCell: (value: unknown) => string;
  displayIsaacToggleButton: (name: string, property: string) => boolean;
}

const CheckForAcceptedMastFoundationFootplate: React.FunctionComponent<
  CheckForAcceptedMastFoundationFootplateProps
> = ({
  data,
  constructionElementEntityId,
  constructionElementParentId,
  constructionElementsName,
  constructionElementProperty,
  isChecked,
  header,
  exceptionCells,
  guiValue,
  formatCell,
  displayIsaacToggleButton,
}) => {
  if (!data) return null;

  const foundAcceptedMast = data.constructionParts.mastParts.masts.find(mast => mast.id === constructionElementEntityId && mast.isAccepted);
  const foundAcceptedFootplate = data.constructionParts.mastParts.footplates.find(footplate => footplate.id === constructionElementEntityId && footplate.isAccepted);
  const foundAcceptedFoundation = data.constructionParts.mastParts.foundations.find(foundation => foundation.id === constructionElementEntityId && foundation.isAccepted);

  if (foundAcceptedMast || foundAcceptedFoundation || foundAcceptedFootplate) {
    if (displayIsaacToggleButton(constructionElementsName, constructionElementProperty)) {
      return (
        <td style={{color: "#ccc"}}>
          <ConstructionTableToggleCell
            constructionElementParentId={constructionElementParentId}
            constructionElementEntityId={constructionElementEntityId}
            isChecked={isChecked}
            disabled={true}
          />
        </td>
      );
    }

    if (exceptionCells.includes(header)) {
      return null;
    }

    return (
      <td style={{color: "#ccc", overflow: "visible"}}>
        <div style={{display: "inline-flex", alignItems: "center", gap: 6}}>
          <MastTooltip show={constructionElementsName === "masts" && constructionElementProperty === "position"} />
          <ConstructionTableFixedCell value={formatCell(guiValue.value)} />
        </div>
      </td>
    );
  }
  return null;
};

export default CheckForAcceptedMastFoundationFootplate;
